// extracted by mini-css-extract-plugin
module.exports = {"button":"i_Iy","icon":"i_Iz"};